import {Component, Input} from '@angular/core';
import {GameStatusBannerData} from "../../interfaces/game-status-banner-data";
import {StoryTheme} from "../../story/card/story-theme";
import {BorderGradientColor} from "../../ts-types/border-gradient-color";

@Component({
  selector: 'brt-game-status-banner',
  templateUrl: './game-status-banner.component.html',
  styleUrls: ['./game-status-banner.component.scss']
})
export class GameStatusBannerComponent {
  protected readonly StoryTheme = StoryTheme;

  @Input('data') set setData(val: GameStatusBannerData) {
    this.data = val;

    if(this.data.colorTheme === "orange") this.borderGradientColor = "orange";
    else if(this.data.colorTheme === "green") this.borderGradientColor = "green";
    else if(this.data.colorTheme === "blue") this.borderGradientColor = "blue";
  }
  data!: GameStatusBannerData;
  borderGradientColor: BorderGradientColor = "orange";
}
